import { AceCard } from '../../../components/AceCard';
import styles from './CreateNewApplicationTab.module.css';
import { useContext } from 'react';
import { ApplicationContext } from '../../../store/context.ts';

import { NonIdealState } from '@blueprintjs/core';
import { AceDividerCard } from '../../../components/AceDividerCard';
import { CreateApplicationForm } from '../../../components/CreateApplicationForm/CreateApplicationForm.tsx';

export function CreateNewApplicationTab() {
  const { state } = useContext(ApplicationContext);
  return (
    <AceCard id={'CreateNewApplication'} title={'Create new application'}>
      {state.marketCountry ? (
        <div className={styles.container}>
          <div className={styles.internalContainer}>
            <AceDividerCard title={'Customer data'}>
              <CreateApplicationForm
                key={state.marketCountry}
                marketCountry={state.marketCountry}
              />
            </AceDividerCard>
          </div>
          <div className={styles.internalContainer}></div>
        </div>
      ) : (
        <NonIdealState>No market country selected!</NonIdealState>
      )}
    </AceCard>
  );
}
